(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.header-cell.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.header-cell.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const TableHeaderCell = _ref => {
  let children = _ref.children,
    className = _ref.className,
    scope = _ref.scope;
  return React.createElement("th", {
    className: clx('tipsinfo_table__header_cell', className),
    scope: scope
  }, children);
};
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableHeaderCell', TableHeaderCell);

 })(window);